import { useContext } from "react";

import DataLoader from "@/components/DataLoader";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { ViewerContext } from "@/tpo/Viewer";

import { UserDatapointModelContent } from "../../UserDatapointModelContent";
import { RELATED_RESEARCH_QUERY, USER_DATAPOINTS_QUERY, USER_DATAPOINT_QUERY } from "./graphql";

export default function ModelContent({ type, item, isGenesTest }) {
  const viewerContext = useContext(ViewerContext);
  const clientId = viewerContext?.userId;
  const { organisation, organisationId } = useOrganisationContext();

  if (type === "datapoints") {
    return (
      <DataLoader
        query={USER_DATAPOINT_QUERY}
        variables={{
          userDatapointId: item.id,
          userId: clientId,
          organisationId: organisation?.id
        }}
        render={({ userDatapoint }) => (
          <UserDatapointModelContent
            userDatapoint={userDatapoint}
            isGenesTest={isGenesTest}
            relatedResearchQuery={RELATED_RESEARCH_QUERY}
            datapointGraphQuery={USER_DATAPOINTS_QUERY}
            datapointGraphSkip={!organisationId}
          />
        )}
      />
    );
  }
  return null;
}
